import React, { createContext, useContext, useState } from 'react';

const HotelContext = createContext();

export const useHotelContext = () => useContext(HotelContext);

export const HotelProvider = ({ children }) => {
    const [hotelData, setHotelData] = useState([]); // For list of hotels
    const [selectedHotelDetails, setSelectedHotelDetails] = useState({}); // Store each selection keyed by hotel index

    return (
        <HotelContext.Provider value={{ hotelData, setHotelData, selectedHotelDetails, setSelectedHotelDetails }}>
            {children}
        </HotelContext.Provider>
    );
};